<template>
  <div class="application-sync-count-container" v-rect-loading="loading">
    <CounterList
      class="application"
      :titleI18nKey="`${i18nPrefix}.label.applicationSync`"
      :data="applicationCountData"
      :countArray="[2, 3]"
    >
      <template #titleBtn>
        <Dropdown
          v-model="day"
          :data="dayRangeList"
          @change="handelDayChange()"/>
      </template>
    </CounterList>
  </div>
</template>

<script>
import _ from 'lodash'
import CounterList from './counterList.vue'
import Dropdown from '@/components/formEditor/dropdown.vue'
import mixin from './countMixin'

const dayRange = [0, 7, 15, 30]

export default {
  mixins: [mixin],
  components: {
    CounterList,
    Dropdown
  },
  data () {
    return {
      i18nPrefix: 'admin.apScheduler',
      day: 0,
      type: 'application',
      loading: false,
      countData: []
    }
  },
  computed: {
    dayRangeList () {
      return _.map(dayRange, item => {
        return { labelI18nKey: `${this.i18nPrefix}.label.dayRange.${item}`, value: item }
      })
    },
    applicationCountData () {
      const i18nPrefix = this.i18nPrefix
      const exceptionCount = this.countData.exception_count || 0
      return [
        { labelI18nKey: `${i18nPrefix}.label.application.success`, value: this.countData.success_application_count || 0 },
        { labelI18nKey: `${i18nPrefix}.label.application.filed`, value: this.countData.failed_application_count || 0 },
        { labelI18nKey: `${i18nPrefix}.label.task.total`, value: this.countData.total_count || 0 },
        { labelI18nKey: `${i18nPrefix}.label.task.exception`, value: exceptionCount, valueColor: exceptionCount > 0 ? '#ee6a6a' : '#67a06f' },
        { labelI18nKey: `${i18nPrefix}.label.task.current`, value: this.countData.current_count || 0 }
      ]
    }
  },
  created () {
    this.initData()
  },
  methods: {
    initData () {
      this.handelLoadData(this.day)
    },
    async handelLoadData (day) {
      this.loading = true
      try {
        this.countData = await this.getCountDataByTypeAndDay(day, this.type)
      } finally {
        this.loading = false
      }
    },
    async handelDayChange () {
      await this.handelLoadData(this.day)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
